import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","TermsAndConditionsPolicyDataId"] */ "/codebuild/output/src2012239524/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
